export const CSV_ENCODING_TYPE = {
  ShiftJis: 'Shift-JIS',
  Utf8: 'UTF-8',
  Windows31j: 'Windows-31J',
} as const
export type CsvEncodingType = (typeof CSV_ENCODING_TYPE)[keyof typeof CSV_ENCODING_TYPE]

export type DownloadTenantShipmentsCsvParams = {
  tenantId: number
  createdAtFrom: string // ISO 8601
  createdAtTo: string // ISO 8601
  encodingType: CsvEncodingType
}

export type DownloadTenantShipmentsCsvResult = {
  blob: Blob
  filename: string | null
}
